module.exports = __webpack_public_path__ + "static/6-14a31ebf2c5ff82ebe11b95a501daf84.jpg";